import { Link } from "@tanstack/react-router";
import { FileQuestion } from "lucide-react";

import { Button } from "@gately/ui/button";

import { StatusScreen } from "./status-screen";

/**
 * Global 404 UI (`defaultNotFoundComponent`) — shown for unmatched routes and
 * `notFound()` throws.
 */
export function NotFoundScreen() {
  return (
    <StatusScreen
      icon={<FileQuestion className="size-6" />}
      title="Page introuvable"
      description="La page que vous cherchez n'existe pas ou a été déplacée."
      actions={
        <Button asChild>
          <Link to="/">Retour à l'accueil</Link>
        </Button>
      }
    />
  );
}
